import React from 'react'
import "./style.css"

const Header = () => {
  return (
    <div className="header">Secret Message</div>
  )
}

export default Header;